import { render } from "./TressButton.vue?vue&type=template&id=205f3c12"
const script = {}

import "./TressButton.vue?vue&type=style&index=0&id=205f3c12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__